import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TriStateCheckBoxComponent } from '@myapp/features/widgets/components';
import { AuthorizationService } from '@myapp/modules/fwcore/services';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { CheckBoxModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { KENDO_LISTVIEW } from '@progress/kendo-angular-listview';

import {
  Component,
  EventEmitter,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlResizerService } from '../../../../../services/framework/control-resizer.service';
import { PowerBIIntegrationService } from '../../../../features/admin/services/PowerBIIntegration.service';
import {
  PowerBIEmbedModule,
  PowerBIReportEmbedComponent,
} from 'powerbi-client-angular';
import {
  Embed,
  IReportEmbedConfiguration,
  models,
  service,
} from 'powerbi-client';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    TextBoxModule,
    FormsModule,
    TriStateCheckBoxComponent,
    CheckBoxModule,
    KENDO_SVGICON,
    KENDO_LISTVIEW,
    PowerBIEmbedModule,
  ],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardComponent {
  models = models;
  @Output() completedLoading = new EventEmitter();

  constructor(
    public serviceAuth: AuthorizationService,
    protected router: Router,
    protected controlResizer: ControlResizerService,
    protected powerBIIntegrationService: PowerBIIntegrationService
  ) {
    this.BuildPowerBIReport();
  }
  BuildPowerBIReport(): void {
    this.powerBIIntegrationService.getPowerBIReportDetails().subscribe(
      (_response) => {
        if(!_response) return;
        let showNavContentPanel = false;

        if (_response?.chart?.showTabNavigation === 'true') {
          showNavContentPanel = true;
        }
        this.embedConfig = {
          type: _response.embedType,
          tokenType: models.TokenType.Embed,
          accessToken: _response.embedToken?.token,
          embedUrl: _response.embedUrl,
          id: _response.id,
          permissions: models.Permissions.All,
          settings: {
            filterPaneEnabled: false,
            navContentPaneEnabled: showNavContentPanel,
          },
        };
      },
      (error) => {
        // Raise Error
        console.error(error);
      }
    );
  }
  @ViewChild(PowerBIReportEmbedComponent)
  reportObj!: PowerBIReportEmbedComponent;

  eventHandlersMap = new Map([
    [
      'loaded',
      (event) => {
        this.completedLoading.emit();
        if (event) {
        }
      },
    ],
    [
      'rendered',
      (event: any) => {
        if (event) {
        }
      },
    ],
    [
      'error',
      (event?: service.ICustomEvent<any>) => {
        if (event) {
        }
      },
    ],
    ['visualClicked', () => console.log('visual clicked')],
    [
      'pageChanged',
      (event) => {
        if (event) {
        }
      },
    ],
  ]) as Map<
    string,
    (event?: service.ICustomEvent<any>, embeddedEntity?: Embed) => void | null
  >;

  public embedConfig: IReportEmbedConfiguration = {
    type: 'report',
    embedUrl: '',
    tokenType: models.TokenType.Embed,
    accessToken: '',
    settings: undefined,
  };

}
